/* ============================================================
   PadelPOV custom product page — front-end controller
   Self-contained. Degrades gracefully. Re-inits in the theme
   editor via shopify:section:load. Namespaced to avoid clashes.
   ============================================================ */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Enable reveal animations only when JS is present (prevents hidden content
  // if the script fails). Runs immediately on parse to minimise any flash.
  document.documentElement.classList.add('ppv-anim');

  /* ---------- reveal on scroll ---------- */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.ppv-reveal:not([data-ppv-reveal-bound])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ppv-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ppv-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.setAttribute('data-ppv-reveal-bound', '1'); io.observe(el); });
  }

  /* ---------- accordions (hero info + FAQ) ---------- */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('[data-ppv-acc-trigger]:not([data-ppv-bound])').forEach(function (btn) {
      btn.setAttribute('data-ppv-bound', '1');
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (panel) panel.hidden = open;
      });
    });
  }

  /* ---------- product forms (variant picker + AJAX ATC) ---------- */
  function initProductForms(scope) {
    (scope || document).querySelectorAll('[data-ppv-product]:not([data-ppv-bound])').forEach(function (rootEl) {
      rootEl.setAttribute('data-ppv-bound', '1');
      var dataEl = rootEl.querySelector('[data-ppv-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      var form = rootEl.querySelector('form[data-ppv-atc]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;

      function currentSelection() {
        var picked = {};
        rootEl.querySelectorAll('input[data-ppv-option]:checked').forEach(function (i) {
          picked[i.getAttribute('data-ppv-option')] = i.value;
        });
        return picked;
      }

      function findVariant() {
        var picked = currentSelection();
        var positions = Object.keys(picked);
        return variants.find(function (v) {
          return positions.every(function (p) { return v.options[p - 1] === picked[p]; });
        });
      }

      function update() {
        var v = findVariant();
        if (!v) return;
        if (idInput) idInput.value = v.id;
        document.querySelectorAll('[data-ppv-price]').forEach(function (el) { el.innerHTML = v.price; });
        document.querySelectorAll('[data-ppv-compare]').forEach(function (el) {
          if (v.compare_raw && v.compare_raw > v.price_raw) { el.innerHTML = v.compare_at; el.style.display = ''; }
          else { el.style.display = 'none'; }
        });
        document.querySelectorAll('[data-ppv-save]').forEach(function (el) {
          if (v.compare_raw && v.compare_raw > v.price_raw) {
            var pct = Math.round((1 - v.price_raw / v.compare_raw) * 100);
            el.textContent = 'Save ' + pct + '%'; el.style.display = '';
          } else { el.style.display = 'none'; }
        });
        document.querySelectorAll('[data-ppv-submit]').forEach(function (btn) {
          var label = btn.querySelector('[data-ppv-submit-label]');
          if (v.available) { btn.disabled = false; if (label) label.textContent = btn.getAttribute('data-label-add') || 'Add to cart'; }
          else { btn.disabled = true; if (label) label.textContent = btn.getAttribute('data-label-soldout') || 'Sold out'; }
        });
      }

      rootEl.querySelectorAll('input[data-ppv-option]').forEach(function (i) {
        i.addEventListener('change', update);
      });
      update();

      if (form) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch) return; // let it POST natively
          e.preventDefault();
          addToCart(form);
        });
      }
    });
  }

  function openDrawer(drawer) {
    if (!drawer) return false;
    if (typeof drawer.open === 'function') { try { drawer.open(); return true; } catch (e) {} }
    drawer.classList.add('active', 'animate');
    drawer.removeAttribute('inert');
    document.body.classList.add('overflow-hidden');
    return true;
  }

  function setLoading(form, on) {
    form.querySelectorAll('[data-ppv-submit]').forEach(function (b) { b.classList.toggle('ppv-is-loading', on); });
    document.querySelectorAll('[data-ppv-sticky-add]').forEach(function (b) { b.classList.toggle('ppv-is-loading', on); });
  }

  function refreshCartCount() {
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-ppv-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
        });
      }).catch(function () {});
  }

  function addToCart(form) {
    var toCheckout = form.getAttribute('data-ppv-checkout') === 'true';
    var drawer = document.querySelector('cart-drawer');
    var sectionEl = drawer ? drawer.closest('.shopify-section') : null;
    var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;
    var fd = new FormData(form);
    if (sectionId && !toCheckout) { fd.append('sections', sectionId); fd.append('sections_url', window.location.pathname); }
    setLoading(form, true);
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    }).then(function (r) {
      if (!r.ok || r.data.status) { throw new Error((r.data && r.data.description) || 'add-failed'); }
      if (toCheckout) { window.location = ROOT + 'checkout'; return; }
      if (sectionId && sectionEl && r.data.sections && r.data.sections[sectionId]) {
        sectionEl.innerHTML = r.data.sections[sectionId];
      }
      var freshDrawer = document.querySelector('cart-drawer');
      if (!openDrawer(freshDrawer)) { window.location = ROOT + 'cart'; return; }
      refreshCartCount();
      document.dispatchEvent(new CustomEvent('ppv:cart:added', { detail: r.data }));
    }).catch(function () {
      // graceful fallback: native form submission still adds the item
      form.submit();
    }).finally(function () { setLoading(form, false); });
  }

  /* ---------- sticky bar add button proxies to the hero form ---------- */
  function initStickyAdd(scope) {
    (scope || document).querySelectorAll('[data-ppv-sticky-add]:not([data-ppv-bound])').forEach(function (btn) {
      btn.setAttribute('data-ppv-bound', '1');
      btn.addEventListener('click', function () {
        var form = document.querySelector('form[data-ppv-atc]');
        if (!form) return;
        if (window.fetch) addToCart(form); else form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
  }

  /* ---------- sticky bar show/hide on scroll (mobile) ---------- */
  function initStickyReveal(scope) {
    (scope || document).querySelectorAll('[data-ppv-sticky]:not([data-ppv-bound])').forEach(function (bar) {
      bar.setAttribute('data-ppv-bound', '1');
      var threshold = parseInt(bar.getAttribute('data-threshold') || '620', 10);
      var breakpoint = parseInt(bar.getAttribute('data-breakpoint') || '880', 10);
      function onScroll() {
        if (window.innerWidth >= breakpoint) { bar.style.transform = 'translateY(120%)'; return; }
        bar.style.transform = window.scrollY > threshold ? 'translateY(0)' : 'translateY(120%)';
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    });
  }

  /* ---------- media gallery: thumbnails + swipe ---------- */
  function initGallery(scope) {
    (scope || document).querySelectorAll('[data-ppv-gallery]:not([data-ppv-bound])').forEach(function (g) {
      g.setAttribute('data-ppv-bound', '1');
      var main = g.querySelector('[data-ppv-gallery-main]');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-ppv-thumb]'));
      if (!main) return;
      var slides = thumbs.map(function (t) { return { full: t.getAttribute('data-full'), alt: t.getAttribute('data-alt') || '' }; });
      var idx = 0;

      function show(i) {
        if (!slides.length) return;
        idx = (i + slides.length) % slides.length;
        var sd = slides[idx];
        main.removeAttribute('srcset'); main.removeAttribute('sizes');
        main.src = sd.full; main.alt = sd.alt;
        thumbs.forEach(function (o, j) { o.setAttribute('aria-current', j === idx ? 'true' : 'false'); });
      }

      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });

      // swipe (mobile)
      var x0 = null, y0 = null;
      var target = main.parentNode || main;
      target.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      target.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        x0 = null; y0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { show(idx + (dx < 0 ? 1 : -1)); }
      }, { passive: true });
    });
  }

  /* ---------- horizontal media slider ---------- */
  function initSlider(scope) {
    (scope || document).querySelectorAll('[data-ppv-slider]:not([data-ppv-bound])').forEach(function (wrap) {
      wrap.setAttribute('data-ppv-bound', '1');
      var track = wrap.querySelector('[data-ppv-slider-track]');
      if (!track) return;
      wrap.querySelectorAll('[data-ppv-slide-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-ppv-slide-nav') === 'next' ? 1 : -1;
          var first = track.querySelector('[data-ppv-slide]');
          var step = first ? first.getBoundingClientRect().width + 16 : 300;
          track.scrollBy({ left: dir * step, behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------- smooth scroll-to (video hero button) ---------- */
  function initScrollTo(scope) {
    (scope || document).querySelectorAll('[data-ppv-scrollto]:not([data-ppv-bound])').forEach(function (a) {
      a.setAttribute('data-ppv-bound', '1');
      a.addEventListener('click', function (e) {
        var t = document.getElementById(a.getAttribute('data-ppv-scrollto'));
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  /* ---------- first-order promo: copy code + apply-to-checkout ---------- */
  function fallbackCopy(text) {
    try {
      var t = document.createElement('textarea');
      t.value = text; t.setAttribute('readonly', '');
      t.style.position = 'absolute'; t.style.left = '-9999px';
      document.body.appendChild(t); t.select(); document.execCommand('copy');
      document.body.removeChild(t);
    } catch (e) {}
  }

  function initPromo(scope) {
    (scope || document).querySelectorAll('[data-ppv-copy]:not([data-ppv-bound])').forEach(function (btn) {
      btn.setAttribute('data-ppv-bound', '1');
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code') || '';
        var badge = btn.querySelector('[data-ppv-copied]');
        var done = function () {
          if (badge) { badge.hidden = false; setTimeout(function () { badge.hidden = true; }, 1600); }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () { fallbackCopy(code); done(); });
        } else { fallbackCopy(code); done(); }
      });
    });

    (scope || document).querySelectorAll('[data-ppv-promo-checkout]:not([data-ppv-bound])').forEach(function (btn) {
      btn.setAttribute('data-ppv-bound', '1');
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code') || '';
        var go = function () { window.location = ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=/checkout'; };
        var form = document.querySelector('form[data-ppv-atc]');
        if (!form || !window.fetch) { go(); return; }
        btn.classList.add('ppv-is-loading');
        var fd = new FormData(form);
        fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        }).then(function () { go(); }).catch(function () { go(); });
      });
    });
  }

  /* ---------- init all ---------- */
  function initAll(scope) {
    initReveal(scope);
    initAccordions(scope);
    initProductForms(scope);
    initStickyAdd(scope);
    initStickyReveal(scope);
    initGallery(scope);
    initSlider(scope);
    initScrollTo(scope);
    initPromo(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else { initAll(document); }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
